var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"agreement-page"},[_c('div',{staticClass:"agreement-page-inner"},[_c('h1',{staticClass:"agreement-page-title"},[_vm._v("用户协议")]),_c('AgreementContent',{attrs:{"type":"userinfo","title":"用户协议"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }